// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-bottom: 40px;
}

/* Each card is a button (shortcut into a filtered list) but must still read as a
   card — hence the reset of the button defaults. */
.stat-card {
  background-color: var(--color-bg-card);
  /* Vertical padding trimmed to bring the card height down by about a third;
     horizontal stays 30px so the cards keep their proportions. */
  padding: 14px 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  text-align: center;
  display: block;
  width: 100%;
  border: none;
  font: inherit;
  cursor: pointer;
  transition: box-shadow 0.15s ease, transform 0.15s ease;
}

.stat-card:hover,
.stat-card:focus-visible {
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.45);
  transform: translateY(-2px);
  outline: none;
}

/* Quiet doorway to the archive, under the Total count. */
.stat-sublink {
  display: inline-block;
  margin-top: 8px;
  color: var(--color-text-muted);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
}

.stat-sublink:hover,
.stat-sublink:focus-visible {
  color: var(--wylie-pink);
  outline: none;
}

.stat-card h3 {
  color: var(--color-text-muted);
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.stat-number {
  --num-color: var(--wylie-pink);
  font-size: 2.1rem;
  font-weight: 700;
  color: var(--num-color);
  margin: 0;
}

.section {
  background-color: var(--color-bg-card);
  padding: 30px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 30px;
}

.section h2 {
  margin-bottom: 20px;
  color: var(--color-text-light);
}

.actions {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 20px;
}

.actions button {
  flex: 1 1;
}

/* Half the row, centred, with the icon sitting left of the label. */
.actions .btn-add-candidate {
  flex: 0 1 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 18px; /* sized to sit level with the 24px icon */
}

/* Recruited is the one positive outcome on the row, so its figure is green rather
   than the default pink.

   This uses the app's established green-for-dark-backgrounds (#5cb85c — the same
   one behind "✓ Contract fully executed" and the emailed ticks on the candidate
   page), NOT the literal brand --wylie-green #1c5f36. On the #2a2a2a card that
   brand green lands at roughly 1.9:1 contrast, well under the 3:1 minimum for
   large text, and reads as near-black. */
.stat-number.is-recruited {
  --num-color: #5cb85c;
}

/* Rejected carries the brand's orange against Recruited's green, so the two
   outcomes read apart at a glance.

   --wylie-coral resolves to #f05f57 here, because index.css defines the palette
   the app actually uses. styles/brand-colors.css declares a different value
   (#e07856) but is imported by nothing, so it renders nowhere — don't be misled by
   it when matching a colour. */
.stat-number.is-rejected {
  --num-color: var(--wylie-coral);
}

/* Offer Declined is an outcome like the two above, but not one of ours — the
   candidate withdrew. Amber keeps it visibly apart from Rejected's coral, so the
   two lost-candidate figures are not mistaken for each other at a glance, without
   borrowing Recruited's green.

   #d99a2b measures 5.9:1 on the #2a2a2a card — comfortably past the 3:1 minimum
   for large text, and in line with its neighbours (Recruited 5.8:1, Rejected
   4.4:1). That is the check which ruled out the literal brand green for
   .is-recruited above. */
.stat-number.is-declined {
  --num-color: var(--declined-color);
}

/* The big numbers pulse to a lighter shade of their own colour (not the grey
   the candidate page's text uses), so each stays in its register; the cards
   around them stay still. --num-color carries the colour so the midpoint can
   be mixed from it. */
.stat-number.next-glow-text {
  animation-name: statNumberPulse;
}
@keyframes statNumberPulse {
  50% { color: color-mix(in srgb, var(--num-color) 55%, white); }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;mDACmD;AACnD;EACE,sCAAsC;EACtC;iEAC+D;EAC/D,kBAAkB;EAClB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,eAAe;EACf,uDAAuD;AACzD;;AAEA;;EAEE,0CAA0C;EAC1C,2BAA2B;EAC3B,aAAa;AACf;;AAEA,yDAAyD;AACzD;EACE,qBAAqB;EACrB,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;EAEE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,sCAAsC;EACtC,aAAa;EACb,mBAAmB;EACnB,wCAAwC;EACxC,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;AACT;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;;;;;;;yCAOyC;AACzC;EACE,oBAAoB;AACtB;;AAEA;;;;;;+BAM+B;AAC/B;EACE,+BAA+B;AACjC;;AAEA;;;;;;;;yBAQyB;AACzB;EACE,kCAAkC;AACpC;;AAEA;;;sBAGsB;AACtB;EACE,+BAA+B;AACjC;AACA;EACE,MAAM,sDAAsD,EAAE;AAChE","sourcesContent":[".stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n  margin-bottom: 40px;\n}\n\n/* Each card is a button (shortcut into a filtered list) but must still read as a\n   card — hence the reset of the button defaults. */\n.stat-card {\n  background-color: var(--color-bg-card);\n  /* Vertical padding trimmed to bring the card height down by about a third;\n     horizontal stays 30px so the cards keep their proportions. */\n  padding: 14px 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  text-align: center;\n  display: block;\n  width: 100%;\n  border: none;\n  font: inherit;\n  cursor: pointer;\n  transition: box-shadow 0.15s ease, transform 0.15s ease;\n}\n\n.stat-card:hover,\n.stat-card:focus-visible {\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.45);\n  transform: translateY(-2px);\n  outline: none;\n}\n\n/* Quiet doorway to the archive, under the Total count. */\n.stat-sublink {\n  display: inline-block;\n  margin-top: 8px;\n  color: var(--color-text-muted);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n\n.stat-sublink:hover,\n.stat-sublink:focus-visible {\n  color: var(--wylie-pink);\n  outline: none;\n}\n\n.stat-card h3 {\n  color: var(--color-text-muted);\n  font-size: 0.9rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.stat-number {\n  --num-color: var(--wylie-pink);\n  font-size: 2.1rem;\n  font-weight: 700;\n  color: var(--num-color);\n  margin: 0;\n}\n\n.section {\n  background-color: var(--color-bg-card);\n  padding: 30px;\n  border-radius: 10px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);\n  margin-bottom: 30px;\n}\n\n.section h2 {\n  margin-bottom: 20px;\n  color: var(--color-text-light);\n}\n\n.actions {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.actions button {\n  flex: 1;\n}\n\n/* Half the row, centred, with the icon sitting left of the label. */\n.actions .btn-add-candidate {\n  flex: 0 1 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  font-size: 18px; /* sized to sit level with the 24px icon */\n}\n\n/* Recruited is the one positive outcome on the row, so its figure is green rather\n   than the default pink.\n\n   This uses the app's established green-for-dark-backgrounds (#5cb85c — the same\n   one behind \"✓ Contract fully executed\" and the emailed ticks on the candidate\n   page), NOT the literal brand --wylie-green #1c5f36. On the #2a2a2a card that\n   brand green lands at roughly 1.9:1 contrast, well under the 3:1 minimum for\n   large text, and reads as near-black. */\n.stat-number.is-recruited {\n  --num-color: #5cb85c;\n}\n\n/* Rejected carries the brand's orange against Recruited's green, so the two\n   outcomes read apart at a glance.\n\n   --wylie-coral resolves to #f05f57 here, because index.css defines the palette\n   the app actually uses. styles/brand-colors.css declares a different value\n   (#e07856) but is imported by nothing, so it renders nowhere — don't be misled by\n   it when matching a colour. */\n.stat-number.is-rejected {\n  --num-color: var(--wylie-coral);\n}\n\n/* Offer Declined is an outcome like the two above, but not one of ours — the\n   candidate withdrew. Amber keeps it visibly apart from Rejected's coral, so the\n   two lost-candidate figures are not mistaken for each other at a glance, without\n   borrowing Recruited's green.\n\n   #d99a2b measures 5.9:1 on the #2a2a2a card — comfortably past the 3:1 minimum\n   for large text, and in line with its neighbours (Recruited 5.8:1, Rejected\n   4.4:1). That is the check which ruled out the literal brand green for\n   .is-recruited above. */\n.stat-number.is-declined {\n  --num-color: var(--declined-color);\n}\n\n/* The big numbers pulse to a lighter shade of their own colour (not the grey\n   the candidate page's text uses), so each stays in its register; the cards\n   around them stay still. --num-color carries the colour so the midpoint can\n   be mixed from it. */\n.stat-number.next-glow-text {\n  animation-name: statNumberPulse;\n}\n@keyframes statNumberPulse {\n  50% { color: color-mix(in srgb, var(--num-color) 55%, white); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
